import { render, staticRenderFns } from "./TeacherTitling.vue?vue&type=template&id=07df14c4"
import script from "./TeacherTitling.vue?vue&type=script&lang=js"
export * from "./TeacherTitling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07df14c4')) {
      api.createRecord('07df14c4', component.options)
    } else {
      api.reload('07df14c4', component.options)
    }
    module.hot.accept("./TeacherTitling.vue?vue&type=template&id=07df14c4", function () {
      api.rerender('07df14c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/TeacherTitling.vue"
export default component.exports